module.exports = __webpack_public_path__ + "static/media/ic_edit.6d59a66e.svg";